var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "modal-close-btn-point" }, [
      _c(
        "div",
        {
          staticClass: "modal-close-btn-container",
          on: {
            click: function($event) {
              return _vm.$emit("close")
            }
          }
        },
        [_c("SVGModalClose")],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "ap-modal-title-big" }, [
      _vm._v("\n        Изменить значение\n    ")
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "ap-modal-element" }, [
      _c("div", { staticClass: "ap-modal-text" }, [
        _vm._v(
          "\n            Введите желаемое значение системного параметра.\n        "
        )
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "ap-modal-input-name" }, [
        _vm._v("\n            " + _vm._s(_vm.dataConfig.value.name) + " "),
        _c("span", { staticClass: "red-text" }, [_vm._v("*")])
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.variableValue,
            expression: "variableValue"
          }
        ],
        staticClass: "cd-modal-text-input",
        attrs: { type: "text" },
        domProps: { value: _vm.variableValue },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.variableValue = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showAlert === "variableValue",
              expression: "showAlert === 'variableValue'"
            }
          ],
          staticClass: "form-alert-danger"
        },
        [_vm._v("\n            Обязательное поле!\n        ")]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "modal-button", on: { click: _vm.submitAdd } }, [
      _vm._v("\n        " + _vm._s(_vm.dataConfig.SubmitButtonText) + "\n    ")
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ap-modal-text" }, [
      _c("span", { staticClass: "red-text bold-text" }, [
        _vm._v(
          "\n            Внимание! Данное значение может серьёзно повлиять на работу приложения.\n            Если не уверены - оставьте данное значение по умолчанию или проконсультируйтесь со специалистом!"
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }